/**
 * @description: 我的收件地址
 * @author: 51fan
 */
<template>
  <div class="receivingAddressContent main-wrap">
    <div class="main-top">
         <el-button icon="iconfont icondaoru" type="primary" plain @click="importOrder" class="h40">{{$lang('批量导入')}}</el-button>
         <el-button icon="iconfont iconxiazai" type="primary" plain @click="downloadAddressTemplate" class="h40">{{$lang('下载模板')}}</el-button>
         <el-button type="primary" @click="rowAdd" icon="iconfont iconxinzeng" class="h40">{{$lang('新增收件地址')}}</el-button>
        <div class="searchParam">
            <div class="searchParamInput">
                <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width:336px !important"></el-input>
            </div>
            <el-button type="primary"  @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{$lang('查询')}}</el-button>
            <el-button type="primary" @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{$lang('清空')}}</el-button>
        </div>
    </div>
         <el-alert type="success" center v-if="showImportResult" @close="closeAlert">
            <div>{{$lang('本次总共导入')}}{{allLength}}{{$lang('条数据')}}，{{successLength}}{{$lang('条导入成功')}}，{{errorLength}}{{$lang('条导入失败')}}。</div>
        </el-alert>
    <div class="main-table">
        <JmsTableScroll
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-edit="rowEdit"
        @row-del="rowDel"
        @size-change="sizeChange"
        @select-change="selectionChange"
        @current-change="currentChange">
                <template slot="isDefault" slot-scope="data">
                    <el-switch
                                v-model="data.row.isDefault"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                :active-value="1"
                                :inactive-value="2"
                                disabled>
                    </el-switch>
                </template>
        </JmsTableScroll>
    </div>
    <el-dialog :title="diglogTitle" v-if="editDialogVisible" :visible.sync="editDialogVisible" width="920px" @close="handleClose" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form class="el-form-edit" ref="tableForm" :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <!-- <el-form-item label="地址识别" class="item-col-4">
          <el-input v-model="analysisAddress" :autosize="{minRows: 5 }"  type="textarea" placeholder="粘贴或者输入整段地址，点击“识别”自动拆分姓名、电话和地址。例如：李小兔，13800138000，上海市黄浦区某某大厦…">
          </el-input>
          <div class="oper">
            <span class="red" @click="discern(0)">智能识别</span>
            <span @click="discern(1)">清空</span>
          </div>
        </el-form-item> -->
        <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name" :minlength="1"  :maxlength="30"  :placeholder="$lang('请填写收件人姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('联系电话')" prop="mobile" class="myDetailItem">
          <el-input v-model="rowData.mobile" :maxlength='13' :placeholder="$lang('请填写收件人联系电话')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('公司名称')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :placeholder="$lang('请填写收件人公司名称')" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="receiverProvinceSearch" :initAddressData="initAddressData" :showLevel="3" @changeValue="senderchangeValue" v-model="rowData.province"> </BaseAddress>
        </el-form-item>
        <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="postalCode">
          <el-input v-model="rowData.zipcode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event)"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
          <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1"  :maxlength="150"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('设为默认')" prop="isDefault1">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="keyBtn" @click="handleSubmit('tableForm')"  class="h40 h104">{{$lang('保存')}}</el-button>
      </div>
    </el-dialog>
    <BatchUpload v-model="upload" :orderTemplate="excelImport" @success="uploadSuccess"></BatchUpload>
  </div>
</template>

<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { RESPONSE_SUCCESS } from '@constants'
import mixin from '@/mixins/mixin.js'
import * as Api from '@api/base/public'
// import BatchUpload from '@/views/place-order/batch-order/BatchUpload'
import BatchUpload from './BatchUpload'
import { addAddress, reqAddressList, updateAddress, delAddress, downloadAddressTemplate, queryAddressAnalysisAddress } from '@api/module/customer'
import { RULES, phoneAndMobile, checkAddressFormat, isNull } from '@utils/rules'
export default {
  name: 'ReceivingAddress',
  components: {
    JmsTableScroll,
    BatchUpload,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      analysisAddress: '',
      keyBtn: false,
      excelImport: 3, // 导入模板
      upload: false,
      showImportResult: false, // 控制导出结果显示
      OrderTemplate: 0, // 模板弹窗,1为下载,2为导入
      diglogTitle: this.$lang('新增收件地址'),
      flag: true,
      searchParam: '',
      rowData: {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        zipcode: '',
        detailedAddress: '',
        isDefault: false,
        type: 2,
        id: '',
        companyName: '',
      },
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
          zipcodeProp: 'zipcode',
        },
        isShowLastLevel: false,
        defaultData: {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          areaId: '',
          areaName: '',
        },
      },
      tableList: [],
      isRowDetailUrl: false,
      rules: {
        name: [RULES.requiredTrim],
        mobile: [RULES.required, { validator: phoneAndMobile }, RULES.lengthTenThirdteen],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.required, { validator: checkAddressFormat }],
      },
      delTitObj: {
        title: this.$lang('删除收件地址'),
        subTitle: this.$lang('你确定要删除该收件地址吗？'),
        threeTitle: '',
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 115,
        border: true,
        selection: false,
        menu: this.flag,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '联系电话', //  扫描员
            prop: 'mobile',
          },
          {
            label: '省份',
            prop: 'provinceName',
          },
          {
            label: '城市',
            prop: 'cityName',
          },
          {
            label: '区域',
            prop: 'areaName',
          },
          // {
          //   label: '乡镇',
          //   prop: 'townshipName',
          // },
          {
            label: '邮编',
            prop: 'zipcode',
          },
          {
            label: '详细',
            prop: 'detailedAddress',
          },
          {
            label: '公司名称',
            prop: 'companyName',
          },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green"></i> ' + '是',
            //     2: '<i class="dot oragin"></i> ' + '否',
            //   }
            //   return map[row.isDefault]
            // },
          },
        ],
      }
    },
  },
  methods: {
    senderchangeValue(data) {
      if (data && data.zipcode) {
        this.rowData.zipcode = data.zipcode
      }
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await Api.GET_QUERY_AREA({ current: 1, size: 9999, zipcode: zipCode })
      if (code === RESPONSE_SUCCESS) {
        const records = data.filter(item => item.type === 4 || item.type === 5)
        if (records.length > 0) {
          this.$refs.receiverProvinceSearch.selectSearchClick(records[0])
        }
      } else {
        this.$message.warning(msg)
      }
    },
    discern(type) {
      let text
      switch (type) {
        case 0:
          console.log(1, { ...this.rowData })
          if (!this.analysisAddress) { return }
          text = this.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  name: person,
                  mobile: phonenum,
                  detailedAddress: detail,
                  provinceName: province,
                  provinceId: provinceCode,
                  cityId: cityCode,
                  cityName: city,
                  areaId: countyCode,
                  areaName: county,
                  province: {
                    provinceName: province,
                    provinceId: provinceCode,
                    cityId: cityCode,
                    cityName: city,
                    areaId: countyCode,
                    areaName: county,
                  },
                }
                this.rowData = Object.assign(this.rowData, obj)
                console.log(2, { ...this.rowData })
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.analysisAddress = ''
          break
        default:
          break
      }
    },
    getParams() {
      return {
        type: 2,
        keyword: this.searchParam,
      }
    },
    // 批量导入
    importOrder() {
      this.upload = true
    },
    uploadSuccess(data) {
      this.showImportResult = true
      this.showBulkResult = false
      this.upload = false
      this.OrderTemplate = 0
      const successList = data.data.success || []
      const failList = data.data.fail || []
      this.successOrightList = successList
      this.failOrightList = failList
      this.allLength = successList.length + failList.length
      this.errorLength = failList.length
      this.successLength = successList.length
      if (this.failOrightList.length > 0) {
        this.tabActive = 1
        this.originList = failList
      } else {
        this.tabActive = 0
        this.originList = successList
      }
      this.multipleSelection = []
      this.isSelectAll = false
      this.pageChange()
    },
    closeAlert() {
      this.showBulkResult = false
      this.showImportResult = false
    },
    // 分割数据
    pageChange() {
      this.originArr = this.splitArray(this.originList)
      this.list = this.originArr[0]
      this.current = 0
      // 触发按钮查询
      this.searchChange()
    },
    splitArray(arr) {
      const a_len = arr.length
      const result = []
      for (let i = 0; i < a_len; i += this.size) {
        result.push(arr.slice(i, i + this.size))
      }
      return result
    },
    // 下载模板
    async downloadAddressTemplate() {
      const res = await downloadAddressTemplate()
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            // IE
            const name = this.$lang('下载地址模板')
            window.navigator.msSaveOrOpenBlob(res, `${name}.xls`)
          } else {
            // 火狐谷歌都兼容
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            const name = this.$lang('下载地址模板')
            elink.setAttribute('download', `${name}.xls`)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          }
        }
      }
    },
    // 关闭模板弹窗
    closeTemplate() {
      this.OrderTemplate = 3
    },
    // 表单保存前
    beforeSubmit() {
      const isDefault = this.rowData.isDefault ? 1 : 2
      return { ...this.rowData, isDefault, ...this.rowData.province, zipcode: this.rowData.zipcode }
    },
    // 弹窗关闭前
    beforehandleClose() {
      this.diglogTitle = this.$lang('新增收件地址')
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      this.diglogTitle = this.$lang('编辑地址')
      const { provinceId, provinceName, cityId, cityName, areaId, areaName, isDefault } = row
      const defaultData = { provinceId, provinceName, cityId, cityName, areaId, areaName}
      this.$nextTick(function () {
        this.$set(this.initAddressData, 'defaultData', defaultData)
      })
      console.log(defaultData)
      return { ...row, type: 2, isDefault: isDefault === 1, province: defaultData }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    clearFormItem () {
      this.rowData = {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        zipcode: '',
        detailedAddress: '',
        isDefault: false,
        type: 2,
        id: '',
        province: {},
      }
      this.initAddressData.defaultData.provinceId = ''
      this.initAddressData.defaultData.provinceName = ''
      this.initAddressData.defaultData.cityId = ''
      this.initAddressData.defaultData.cityName = ''
      this.initAddressData.defaultData.areaId = ''
      this.initAddressData.defaultData.areaName = ''
      this.$refs.receiverProvinceSearch.clearInput()
      this.$refs['tableForm'].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.oper{
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;
  .red{
    color: red;
    margin-right: 20px;
  }
}
.el-table th.gutter {
  display: table-cell !important;
}
.receivingAddressContent {
.main-top{
       padding:16px 24px;
       background-color: #fff;
  }
  .main-table{
    padding: 12px 24px;
    background: #edeef3;
    flex: 1
  }
  .searchParam {
    margin-top: 10px;
    display: inline-flex;
    width: 100%;
    position: relative;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .buttons {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot {
    margin-right: 5px;
    width: 6px;
    height: 6px;
    background: #999;
    display: inline-flex;
    vertical-align: middle;
    border-radius: 50%;
    &.yellow {
      background: #ffa111;
    }
    &.green {
      background: #00da00;
    }
    // &.active::before {
    //   background: rgba(0, 218, 0, 1);
    // }
  }
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
          .el-input{
             width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.dot {
    margin-right: 5px;
    width: 6px;
    height: 6px;
    background: #999;
    display: inline-flex;
    vertical-align: middle;
    border-radius: 50%;
    &.yellow {
      background: #ffa111;
    }
    &.green {
      background: #00da00;
    }
  }
.tableHead {
  background: #fafafa;
}
</style>

<style lang="scss">
.receivingAddressContent{
    .el-table__fixed, .el-table__fixed-right{
        height: 680px !important;
    }
}
</style>
